export default __webpack_public_path__ + "static/media/bg_tomodachi_hover.1decf5ee.svg";